<div class="amenity_info">
    <h4 class="text-left" style="border-bottom: 1px solid lightgrey;">Amenities</h4>
    <div class="my-2">
            <div class="rum-facility-info">
                <p>Accessible by lift</p>
                <p>Adapted bath</p>
                <p>Air conditioning</p>
                <p>Alarm clock</p>
                <p>Bath or Shower</p>
                <p>Body soap</p>
                <p>Cable Channels</p>
                <p>Carpeted</p>
                <p>Conditioner</p>
                <p>Desk</p>
                <p>Emergency cord in bathroom</p>
                <p>Entire unit located on ground floor</p>
                <p>Entire unit wheelchair accessible</p>
                <p>Fire extinguisher</p>
                <p>Flat-screen TV</p>
                <p>Free toiletries</p>
                <p>Hairdryer</p>
                <p>Heated pool</p>
                <p>Heating</p>
                <p>Hypoallergenic</p>
                <p>Hypoallergenic pillow</p>
                <p>Iron</p>
                <p>Ironing Facilities</p>
                <p>Key card access</p>
                <p>Laptop safe</p>
                <p>Linen</p>
                <p>Lowered sink</p>
                
            </div>
    </div>
    <div class="float-right">
        <button class="btn btn-primary close_btn" (click)="onClose()">Close</button>
    </div>
</div>